import { useAuth } from 'modules/common/hooks/useAuth';

export function useCanSeeNotification() {
  return useAuth();
}
